import { render, staticRenderFns } from "./QuoteMovements.vue?vue&type=template&id=53857ae5&scoped=true&"
import script from "./QuoteMovements.vue?vue&type=script&lang=js&"
export * from "./QuoteMovements.vue?vue&type=script&lang=js&"
import style0 from "./QuoteMovements.vue?vue&type=style&index=0&id=53857ae5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53857ae5",
  null
  
)

export default component.exports